export const ORDER_STATUS = Object.freeze({
  AWAITING_PAYMENT: 'AWAITING_PAYMENT',
  AWAITING_INVOICING: 'AWAITING_INVOICING',
  AWAITING_RELEASE: 'AWAITING_RELEASE',
  AWAITING_PAYMENT_CONFIRMATION: 'AWAITING_PAYMENT_CONFIRMATION',
  AWAITING_POSTING: 'AWAITING_POSTING',
  AWAITING_DELIVERY: 'AWAITING_DELIVERY',
  DELIVERED: 'DELIVERED',
  CANCELED: 'CANCELED',
  REFUND: 'REFUND',
  AWAITING_CONFIRMATION: 'AWAITING_CONFIRMATION',
  REPROVED: 'REPROVED',
  AWAITING_CREDIT: 'AWAITING_CREDIT',
})

export const ORDER_STATUS_BY_VALUE = Object.freeze({
  1: ORDER_STATUS.AWAITING_PAYMENT,
  2: ORDER_STATUS.AWAITING_INVOICING,
  3: ORDER_STATUS.AWAITING_RELEASE,
  4: ORDER_STATUS.AWAITING_PAYMENT_CONFIRMATION,
  5: ORDER_STATUS.DELIVERED,
  6: ORDER_STATUS.CANCELED,
  7: ORDER_STATUS.AWAITING_POSTING,
  8: ORDER_STATUS.AWAITING_DELIVERY,
  9: ORDER_STATUS.REFUND,
  10: ORDER_STATUS.AWAITING_CONFIRMATION,
  11: ORDER_STATUS.REPROVED,
  12: ORDER_STATUS.AWAITING_CREDIT,
})